;
(function (
    global,
    $,
    undefined
) {
    function setVwFactionProperty() {
        let vw = document.documentElement.clientWidth / 100;
        let contentType = $('[data-conten-type]').data('contenType') || 'page';
        let maxWidth = $('[data-conten-type]').css('max-width');
        document.documentElement.style.setProperty('--vw-fraction', `${vw}px`);

        if (maxWidth) {
            document.documentElement.style.setProperty('--content-max-width', `var(--${contentType}-content-max-width, ${maxWidth})`);
        }
    }

    $(document).ready(setVwFactionProperty);
    window.addEventListener('resize', setVwFactionProperty);
}) (
    window,
    jQuery,
);

(function (
    global,
    $,
    moduleRegistrar,
    Module
) {
    /**
     * Smooth scrolling class.
     */
    class SmoothScrolling
    {
        /**
         * @since 1.0.0
         */
        constructor()
        {
            // Smooth scroll timings.
            this.scrollTimings = {
                'linear': function linear(t) {
                    return t;
                },
                'ease-in': function easeIn(t) {
                    return t * t;
                },
                'ease-out': function easeOut(t) {
                    return t * (2 - t);
                },
                'ease-in-out': function easeInOut(t) {
                    return t < .5 ? 2 * t * t: -1 + (4 - 2 * t) * t;
                }
            };
        }

        /**
         * Fallback for browsers which do not support scrollTop 'behavior' argument for smooth scrolling.
         *
         * @param {number} startPos
         * @param {number} endPos
         * @param {number} duration
         * @param {string} timingType
         * @since 1.0.0
         */
        smoothScrollFallback(startPos, endPos, duration, timingType)
        {
            let setTiming = this.scrollTimings[timingType];
            let start = null;

            // Abort if on top already.
            if (startPos === endPos) {
                return;
            }

            let step = function(timestamp) {
                start = start || timestamp;
                let progress = timestamp - start,

                    time = Math.min(1, ((timestamp - start) / duration));

                if (startPos > endPos) {
                    time = (time - 1.0) * -1;
                    window.scrollTo(0, endPos + (setTiming(time) *  (startPos - endPos)));
                } else {
                    if (startPos + (setTiming(time) * endPos) < endPos) {
                        window.scrollTo(0, startPos + (setTiming(time) * endPos));
                    } else {
                        window.scrollTo(0, endPos);
                    }
                }

                if (progress < duration) {
                    window.requestAnimationFrame(step);
                }
            };

            window.requestAnimationFrame(step);
        }

        /**
         * Smooth scrolling.
         *
         * @param e
         * @since 1.0.0
         */
        smoothScroll(e)
        {
            let el = e.target || e.srcElement;

            if (typeof el === 'undefined'
                || typeof el.pathname === 'undefined'
                || typeof location.pathname === 'undefined'
            ) {
                return;
            }

            // Menu links linking to HTML anchors.
            if (el.parentNode.classList.contains('c-menu__item')) {
                let menuItem = document.querySelector('.c-menu__item.is-current');
                if (null !== menuItem) {
                    menuItem.classList.remove('is-current');
                }

                el.parentNode.classList.add('is-current');
            }

            // On-page links.
            if (location.pathname.replace(/^\//, '') === el.pathname.replace(/^\//, '')
                && location.hostname === el.hostname
            ) {
                // Scroll start position.
                let start = window.pageYOffset;

                // ID of element to scroll to.
                let target = el.hash;
                target = target.length ? target : document.querySelector('[name=' + e.hash.slice(1) + ']');

                // Scroll offset to make up for fixed headers.
                let offset = 80;

                // Verify that the scroll target exist, and scroll to it.
                if (target.length && typeof window.scrollTo === 'function') {
                    e.preventDefault();

                    if (document.querySelector(target)) {
                        let end = 0;
                        if ('#header' !== target) {
                            end = start + document.querySelector(target).getBoundingClientRect().top - offset;
                        }

                        if ('scrollBehavior' in document.documentElement.style) {
                            window.scrollTo({
                                top: end,
                                behavior: 'smooth'
                            });
                        } else {
                            this.smoothScrollFallback(start, end, 1500, 'ease-in-out');
                        }
                    }
                }
            }
        }

        /**
         * Smooth scroll init.
         * Adds event listener to on-page links.
         */
        init()
        {
            $('a[href*="#"]:not([href="#"]):not([href="#0"])').on('click', (e) => {
                // e.preventDefault();
                this.smoothScroll(e);
            });
        }
    }

    moduleRegistrar.register(new Module('webscape-smooth-scrolling', SmoothScrolling));
}) (
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module
);

(function (
    global,
    $,
    moduleRegistrar,
    Module,
    windowHelper,
    undefined
) {
    /**
     * Navigation menu class.
     */
    class NavMenu
    {
        selectors = {
            pageHeader: '[data-js="page-header"]',
            headerMain: '[data-js="page-header-main"]',
            navMenu: '[data-js~="nav-menu"]',
            navMenuDesktop: '[data-js~="nav-menu-desktop"]',
            navMenuMobile: '[data-js~="nav-menu-mobile"]',
            subMenu: '[data-js="nav-menu-submenu"]',
            menuItem: '[data-js="nav-menu-item"]',
            menuItemContent: '[data-js="nav-menu-item-content"]',
            mobileMenuButton: '[data-js="nav-menu-trigger"]',
            toTheTopButton: '[data-js="to-the-top"]',
            menuChildsTrigger: '[data-js="nav-menu-submenu-trigger"]',
            screenReaderShow: '[data-js="srt-show"]',
            screenReaderHide: '[data-js="srt-hide"]',
            isOpen: '.is-open',
            link: '.c-link',
            hasChildren: '[data-js="nav-menu-item"].has-children',
            hasChildrenIsOpen: '[data-js="nav-menu-item"].has-children.is-open',
        };

        classes = {
            menu: 'c-menu',
            link: 'c-link',
            flex: 'flex',
            open: 'is-open',
            hidden: 'hidden',
            transformed: 'is-transformed',
            noScroll: 'no-scroll',
        };

        menuAnimation = 'fade';

        menuAnimations = {
            'slide-vertical': {
                name: 'slide-v',
                duration: 250
            },
            'slide-horizontal': {
                name: 'slide-h',
                duration: 250
            },
            'fade': {
                name: 'fade',
                duration: 400
            },
        };

        mobileMaxWidth = 1199;

        /**
         * @since 1.0.0
         */
        constructor(el)
        {
            this.el = el;

            this.init();
        }

        /**
         * Mobile nav menu animation.
         *
         * @param {string} action
         * @since 1.0.0
         */
        animateMenu(action)
        {
            const animation = this.menuAnimation;

            if ('open' === action) {
                switch (animation) {
                    case 'slide-vertical':
                        $(this.el).animate({ height: '100vh' }, this.menuAnimations[animation].duration);
                        break;
                    case 'slide-horizontal':
                        $(this.el).animate({ left: 0, height: '100vh' }, this.menuAnimations[animation].duration);
                        break;
                    case 'fade':
                        $(this.el).css({ height: '100vh' });
                        $(this.el).animate({ opacity: '1' }, this.menuAnimations[animation].duration);
                        break;
                }
            } else {
                switch (animation) {
                    case 'slide-vertical':
                        $(this.el).animate({ height: 0 }, this.menuAnimations[animation].duration);
                        break;
                    case 'slide-horizontal':
                        $(this.el).animate({ left: '-100vw', height: '100vh' }, this.menuAnimations[animation].duration);
                        break;
                    case 'fade':
                        $(this.el).animate({ opacity: '0' }, this.menuAnimations[animation].duration);
                        setTimeout(() => {
                            $(this.el).css({ height: '0' })
                        }, this.menuAnimations[animation].duration);
                        break;
                }
            }
        }

        /**
         * Sets menu item attributes.
         *
         * @param {object} item
         * @param {object} button
         * @param {object} link
         * @param {string|null} action
         * @since 1.0.0
         */
        setItem(item, button, link, action = null)
        {
            let subMenu = link.next(this.selectors.subMenu);
            let subMenuLevel = subMenu.data('level');

            if ('close' === action || item.hasClass(this.classes.open)) {
                item.removeClass(this.classes.open);

                if (0 === subMenuLevel || windowHelper.width() <= this.mobileMaxWidth) {
                    subMenu.animate({ height: '0' }, 125, 'swing');
                }

                item.find(this.selectors.menuItemContent).attr('aria-expanded', 'false');
                button.attr('aria-expanded', 'false');
                button.find(this.selectors.screenReaderShow).attr('aria-hidden', 'false');
                button.find(this.selectors.screenReaderHide).attr('aria-hidden', 'true');
            } else {
                item.addClass(this.classes.open);

                if (0 === subMenuLevel || windowHelper.width() <= this.mobileMaxWidth) {
                    subMenu.animate({ height: subMenu.data('children') * 48 + 'px' }, 125, 'swing');
                }

                item.find(this.selectors.menuItemContent).attr('aria-expanded', 'true');
                button.attr('aria-expanded', 'true');
                button.find(this.selectors.screenReaderShow).attr('aria-hidden', 'true');
                button.find(this.selectors.screenReaderHide).attr('aria-hidden', 'false');
            }
        }

        /**
         * Navigation menu initialization.
         * Adds event listeners.
         *
         * @since 1.0.0
         */
        init()
        {
            this.menuAnimation = $(this.el).attr('data-menu-animation');
            this.menuDrodownTrigger  = $(this.el).attr('data-menu-dropdown');

            if ('click' === this.menuDrodownTrigger) {
                $(this.el).find(this.selectors.hasChildren).on('click', (e) => {
                    let currentTarget = $(e.currentTarget);
                    this.setItem(currentTarget, currentTarget.find('button').first(), currentTarget.find('span').first());
                });
            } else {
                $(this.el).find(this.selectors.hasChildren).on('mouseenter', (e) => {
                    let currentTarget = $(e.currentTarget);

                    if (currentTarget.hasClass(this.classes.open)) {
                        return;
                    }

                    this.setItem(currentTarget, currentTarget.find('button').first(), currentTarget.find('a').first(), 'open');
                }).on('mouseleave', (e) => {
                    let currentTarget = $(e.currentTarget);
                    if (!currentTarget.hasClass(this.classes.open)) {
                        return;
                    }

                    setTimeout(() => {
                        this.setItem(currentTarget, currentTarget.find('button').first(), currentTarget.find('a').first(), 'close');
                    }, 150);
                });
            }

            // Mobile menu button.
            $(this.selectors.mobileMenuButton + '[data-menu="' + $(this.el).data('menu') + '"]').on('click', (e) => {
                if ($(this.selectors.navMenuMobile).hasClass(this.classes.open)) {
                    $(this.selectors.navMenuMobile).removeClass(this.classes.open);
                    $(e.currentTarget).removeClass(this.classes.open);
                    $(e.currentTarget)
                        .attr('aria-label', $(e.currentTarget).data('ariaLabel'))
                        .attr('title', $(e.currentTarget).data('ariaLabel'));

                    this.animateMenu('close');

                    $('html').removeClass(this.classes.noScroll);
                } else {
                    $(this.selectors.navMenuMobile).addClass(this.classes.open);
                    $(e.currentTarget).addClass(this.classes.open);
                    $(e.currentTarget)
                        .attr('aria-label', $(e.currentTarget).data('ariaLabelExpanded'))
                        .attr('title', $(e.currentTarget).data('ariaLabelExpanded'));

                    this.animateMenu('open');

                    $('html').addClass(this.classes.noScroll);
                }

                $(e.currentTarget).attr('aria-expanded', !JSON.parse($(e.currentTarget).attr('aria-expanded')));
            });

            // Menu items with HTML anchors.
            $(this.el).find(this.selectors.menuItemContent).on('click', (e) => {
                if (/#/.test($(e.currentTarget).find('> a').first().attr('href'))) {
                    $(this.selectors.navMenu).removeClass(this.classes.open);
                    $(this.selectors.mobileMenuButton + '[data-menu="' + $(this.el).data('menu') + '"]')
                        .removeClass(this.classes.open);
                    $(this.selectors.mobileMenuButton).attr('aria-expanded', 'false');

                    this.animateMenu('close');

                    $('html').removeClass(this.classes.noScroll);
                }
            });

            // Mobile menu items.
            $(this.el).on('click', this.selectors.menuChildsTrigger, (e) => {
                e.preventDefault();

                let menuButton = $(e.currentTarget);
                let menuLink;

                if (menuButton.hasClass(this.classes.link)) {
                    menuLink = menuButton;
                    menuButton = menuButton.find('button').first();
                } else {
                    menuLink = menuButton.parent().find(this.selectors.link);
                }

                this.setItem(menuLink.parent(), menuButton, menuLink);
            });

            $('.js-menu-level-up-trigger').on('click', () => {
                if (null === $(this.el).find(this.selectors.hasChildrenIsOpen).length) {
                    $(this.selectors.mobileMenuButton + '[data-menu="' + $(this.el).data('menu') + '"]')
                        .removeClass(this.classes.open);
                    $(this.el)
                        .removeClass(this.classes.open, this.classes.flex);
                }

                $(this.el).find(this.selectors.hasChildrenIsOpen)
                    .last()
                    .parent()
                    .find(this.selectors.isOpen)
                    .removeClass(this.classes.open);
            });

            // Window scroll event.
            $(window).on('scroll', () => {
                // Show/hide to the top button.
                if (windowHelper.scrollTop() < windowHelper.height()) {
                    $(this.selectors.toTheTopButton)
                        .addClass(this.classes.hidden);
                } else {
                    $(this.selectors.toTheTopButton)
                        .removeClass(this.classes.hidden);
                }

                let pageHeader = $(this.selectors.pageHeader);
                let headerMain = $(this.selectors.headerMain);

                // Transform header.
                if (windowHelper.scrollTop() > 160) {
                    pageHeader.addClass(this.classes.transformed);
                    headerMain.attr('style', headerMain.attr('data-transform-style'));
                } else if (windowHelper.scrollTop() === 0) {
                    pageHeader.removeClass(this.classes.transformed);
                    headerMain.attr('style', headerMain.attr('data-style'));
                }
            });

            /*$(window).on('resize', () => {
                if (windowHelper.getWidth() > this.mobileMaxWidth) {
                    $(this.el).css({ height: '', display: '' })
                } else {
                    $(this.el).css({ height: '0' })
                }
            });*/
        }
    }

    moduleRegistrar.register(new Module('webscape-nav-menu', NavMenu, '[data-js~="nav-menu"]'));
}) (
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar,
    window.webSCAPE.Module,
    window.webSCAPE.moduleRegistrar.getInstance('webscape-window')
);


(function(
    global,
    $,
    NavMenu,
    SmoothScrolling
) {
    $(document).ready(function () {
        let smoothScrolling = new SmoothScrolling();
        smoothScrolling.init();
    });
}) (
    window,
    jQuery,
    window.webSCAPE.moduleRegistrar.getModule('webscape-nav-menu').getClass(),
    window.webSCAPE.moduleRegistrar.getModule('webscape-smooth-scrolling').getClass()
);
